import React, {useState} from 'react';
import { Button, Modal,} from 'react-bootstrap';
import FalconCloseButton from 'components/common/FalconCloseButton';
import IconButton from 'components/common/IconButton';
import { DocusealForm } from '@docuseal/react'
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';

import { Axios } from 'helpers/axios';

const DocDPSsignModal = ({
    doc,
}) => {
    const [isLoading, setIsLoading] = useState(true);
    const [token, setToken] = useState();
    const [docuHost, setDocuHost] = useState();
    const [masquerBouton, setMasquerBouton] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const handleCloseModal = () => {
        setShowModal(false);
        setToken();
    }
    const handleShowModal = async () => {
        try {
            setIsLoading(true);
            await initComponent();
            setIsLoading(false);
            setShowModal(true);
        } catch (error) {
            console.error(error)
        }
    }

    const initComponent = async () => {
        try {
            const getTokOneDoc = await Axios.post('/authenticatedRoutes/dps/getDocusealTokenForLiveSign',{
                ...doc,
            });
            setToken(getTokOneDoc.data.token);
            setDocuHost(getTokOneDoc.data.docuHost);

            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    const pushDoneToBP = async () => {
        try {
            const getTokOneDoc = await Axios.post('/authenticatedRoutes/dps/getDocusealWaitingOneDocDPS',{
                ...doc,
            });
            setToken(getTokOneDoc.data.token);
            setDocuHost(getTokOneDoc.data.docuHost);

            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    return(<>
        {!masquerBouton ?
            <IconButton
                icon='signature'
                variant="primary"
                onClick={handleShowModal}
                className={'mt-3'}
            >{doc.nomDocumentDPS}</IconButton>
        : null}
        
        <Modal show={showModal} onHide={handleCloseModal} backdrop="static" keyboard={false} fullscreen>
            <Modal.Header>
                <Modal.Title>{doc.nomDocumentDPS}</Modal.Title>
                <FalconCloseButton onClick={handleCloseModal}/>
            </Modal.Header>
            <Modal.Body>
                {isLoading ?
                    <LoaderInfiniteLoop/>
                :
                    <DocusealForm
                        token={token}
                        src={'https://'+docuHost+'/s/'+doc.slug}
                        onComplete={()=>{setMasquerBouton(true);pushDoneToBP();}}
                        onDecline={()=>{setMasquerBouton(true);pushDoneToBP();}}
                        orderAsOnPage={true}
                        withDecline={true}
                    />
                }
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                    Fermer
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}

DocDPSsignModal.propTypes = {};

export default DocDPSsignModal;
